<template>
  <v-container fluid class="job-documents-page">
    <v-btn fab flat @click.native="goback" v-if="notrue">
      <v-icon class="pointer" v-ripple>arrow_back</v-icon>
    </v-btn>
    <v-layout class="errorbox" v-if="notrue">
      <v-flex
        >Seems like you don't have any permissions. Please contact
        administrator</v-flex
      >
    </v-layout>
    <v-card class="job-documents-header" v-if="!notrue">
      <v-card-title class="bg-clr p-t-0">
        <v-layout wrap>
          <v-btn fab flat @click.native="goback">
            <v-icon class="pointer" v-ripple>arrow_back</v-icon>
          </v-btn>
          <v-flex>
            <v-layout>
              <v-flex>
                <span class="color-orange breakword">Documents </span></v-flex
              ></v-layout
            >
            <v-layout>
              <v-flex>
                <span class="color-grey-light"
                  >Job Id-{{ this.jobId }}, Assignment Id:{{
                    this.assignId
                  }}</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-card raised class="job-documents-content" v-if="!notrue">
      <v-flex xs12 pt-4>
        <div class="job-documents-tabs-wrap">
          <SegmentedControl
            class="job-documents-segmented"
            aria-label="Document type"
            :value="currentTab"
            :options="documentTabOptions"
            @change="onDocumentTabChange"
          />
        </div>
        <!-- <v-flex
          :href="`#driverDoc`"
          class="m-t-20"
          v-if="currentTab == 'driverDoc'"
          md12
        >
          <receive-driver-doc
            :customerStatus="customerStatus"
            :tabFilter="currentTab"
          />
        </v-flex> -->
        <v-flex
          :href="`#shipmentDocument`"
          class="m-t-20 job-documents-tab-panel"
          v-if="currentTab == 'shipmentDocument'"
          md12
        >
          <documentList
            :customerStatus="customerStatus"
            :tabFilter="currentTab"
          />
        </v-flex>
        <v-flex
          :href="`#AdditionalDocument`"
          class="m-t-20 job-documents-tab-panel"
          v-if="currentTab == 'AdditionalDocument'"
          md12
        >
          <additionalChargesList
            :customerStatus="customerStatus"
            :tabFilter="currentTab"
          />
        </v-flex>
        <v-flex
          :href="`#AdvanceDocument`"
          class="m-t-20 job-documents-tab-panel"
          v-if="currentTab == 'AdvanceDocument'"
          md12
        >
          <generateAdvanceList
            :customerStatus="customerStatus"
            :tabFilter="currentTab"
          />
        </v-flex>
        <v-flex
          :href="`#DeliveryDocument`"
          class="m-t-20 job-documents-tab-panel"
          v-if="currentTab == 'DeliveryDocument'"
          md12
        >
          <deliveryProofList
            :customerStatus="customerStatus"
            :tabFilter="currentTab"
          />
        </v-flex>
      </v-flex>
    </v-card>
  </v-container>
</template>
<script>
import _ from "lodash";
import { EventBus } from "../../event-bus.js";
import documentList from "./documentList";
import generateAdvanceList from "./generateAdvanceList";
import deliveryProofList from "./deliveryProofList";
import additionalChargesList from "./additionalChargesList";
import receiveDriverDoc from "./receiveDriverDoc";
import Loading from "vue-loading-overlay";
import SegmentedControl from "@/components/Common/SegmentedControl";

export default {
  components: {
    receiveDriverDoc,
    Loading,
    documentList,
    additionalChargesList,
    generateAdvanceList,
    deliveryProofList,
    SegmentedControl,
  },
  created() {
    let roles = JSON.parse(localStorage.getItem("permissions")).roles;

    let documentRole = [
      "edit-additional-charges",
      "edit-additional-charges",
      "generate-advance-jobs",
      "Add-proof-of-Delivery",
    ];
    let operationss = {};

    roles.filter((x) => {
      if (x.role.roleName == "jobs" || x.role.roleName == "procurement") {
        operationss = x.operations.map((y) => y.operationName);
        if (
          x.operations == "Add-proof-of-Delivery" ||
          x.operations == "edit-additional-charges" ||
          x.operations == "add-documents-jobs"
        ) {
          if (
            operationss.includes("Add-proof-of-Delivery") &&
            operationss.includes("edit-additional-charges") &&
            operationss.includes("add-documents-jobs")
          ) {
            this.notrue = false;
          }
          if (
            operationss.includes("Add-proof-of-Delivery") &&
            operationss.includes("edit-additional-charges")
          ) {
            this.notrue = false;
          }
          if (
            operationss.includes("Add-proof-of-Delivery") &&
            operationss.includes("edit-additional-charges") &&
            operationss.includes("add-documents-jobs")
          ) {
            this.notrue = false;
          }
          if (
            operationss.includes("Add-proof-of-Delivery") &&
            operationss.includes("add-documents-jobs")
          ) {
            this.notrue = false;
          }
          if (
            operationss.includes("add-documents-jobs") &&
            operationss.includes("edit-additional-charges")
          ) {
            this.notrue = false;
          }
          // if (

          //   operationss.includes("add-documents-jobs") &&
          //   operationss.includes("edit-additional-charges")
          // ) {
          //   this.notrue = false;
          // }
          // if (

          //   operationss.includes("add-documents-jobs")
          // ) {
          //   this.notrue = false;
          // }
          if (
            operationss.includes("add-documents-jobs") &&
            operationss.includes("edit-additional-charges")
          ) {
            this.notrue = false;
          }
          if (
            operationss.includes("generate-advance-jobs") &&
            operationss.includes("edit-additional-charges")
          ) {
            this.notrue = false;
          }
          // if (

          //   operationss.includes("edit-additional-charges")
          // ) {
          //   this.notrue = false;
          // }
          if (
            operationss.includes("Add-proof-of-Delivery") &&
            operationss.includes("add-documents-jobs")
          ) {
            this.notrue = false;
          }
          // if (
          //   operationss.includes("Add-proof-of-Delivery")
          // ) {
          //   this.notrue = false;
          // }
          if (operationss.includes("Add-proof-of-Delivery")) {
            this.notrue = false;
          }
          if (operationss.includes("edit-additional-charges")) {
            this.notrue = false;
          }
          // if (operationss.includes("generate-advance-jobs")) {
          //   this.notrue = false;
          // }
          if (operationss.includes("add-documents-jobs")) {
            this.notrue = false;
          }
        } else {
          this.notrue = false;
        }
      }
    });

    this.$eventBus.$on("data", (val) => {
      this.jobId = val.jobId;
      this.assignId = val.assignmentId;
    });

    let userPermissions = JSON.parse(
      localStorage.getItem("permissions")
    ).permissions;
    // let tabs=['shipmentDocumnet','DeliveryDocument','AdvanceDocument','DeliveryDocument']
    let object = {
      "add-documents-jobs": "shipmentDocument",
      "edit-additional-charges": "AdditionalDocument",
      "generate-advance-jobs": "AdvanceDocument",
      "Add-proof-of-Delivery": "DeliveryDocument",
    };
    let object1 = {};
    for (var i = 0; i < userPermissions.length; i++) {
      if (object[userPermissions[i].operationName]) {
        if (
          this.$route.query.type === "Driver_Proof" &&
          operationss.includes("Add-proof-of-Delivery")
        ) {
          this.currentTab = "DeliveryDocument";
          this.TabStatus = "DeliveryDocument";
        } else {
          this.currentTab = object[userPermissions[i].operationName];
          this.TabStatus = object[userPermissions[i].operationName];
        }
        break;
      }
    }
    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });
    this.$eventBus.$on("on-load", () => {
      this.loading = true;
    });
  },
  data() {
    return {
      operationName: "",
      notrue: true,
      currentTab: "DeliveryDocument",
      TabStatus: "DeliveryDocument",
      jobId: "",
      customerStatus: "",
      assignId: "",
      items: {
        list: [],
      },
      active: "0",

      loading: true,
      search: "",

      payload: {
        skip: "0",
        limit: "15",
      },
    };
  },
  computed: {
    documentTabOptions() {
      const options = [];
      if (this.hasDocumentPermission("add-documents-jobs")) {
        options.push({
          label: "Shipment Doc",
          value: "shipmentDocument",
          icon: "description",
        });
      }
      if (this.hasDocumentPermission("Add-proof-of-Delivery")) {
        options.push({
          label: "Proof of Delivery",
          value: "DeliveryDocument",
          icon: "assignment_turned_in",
        });
      }
      return options;
    },
  },
  methods: {
    hasDocumentPermission(operationName) {
      try {
        const data = JSON.parse(localStorage.getItem("permissions") || "{}");
        const fromPermissions = (data.permissions || []).some(
          (item) => item.operationName === operationName
        );
        if (fromPermissions) {
          return true;
        }
        return (data.roles || []).some((role) =>
          (role.operations || []).some(
            (operation) =>
              operation === operationName ||
              operation.operationName === operationName
          )
        );
      } catch (error) {
        return false;
      }
    },
    onDocumentTabChange(section) {
      if (section === "shipmentDocument") {
        this.checkShipment(section);
        return;
      }
      if (section === "DeliveryDocument") {
        this.checkDelivery(section);
        return;
      }
      if (section === "AdditionalDocument") {
        this.checkAdditional(section);
        return;
      }
      if (section === "AdvanceDocument") {
        this.checkAdvance(section);
      }
    },
    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.$emit("on-block");
    },
    async checkShipment(section) {
      this.operationName = "add-documents-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },
    async checkAdvance(section) {
      this.operationName = "generate-advance-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },
    async checkDelivery(section) {
      this.operationName = "Add-proof-of-Delivery";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },
    async checkAdditional(section) {
      this.operationName = "edit-additional-charges";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },
    goback() {
      this.$router.go(-1);
    },
    viewTab(flag) {
      this.currentTab = flag;
    },

    startLoad() {
      this.loading = true;
    },
    stopLoad() {
      this.loading = false;
    },

    load(event) {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.table-header-item1 {
  font-size: 16px !important;
  color: #484848;
  font-weight: bold;
}

td {
  font-size: 16px !important;
}

thead {
  background: #efefef;
}
.track-btn {
  background-color: #ffeeda !important;
}
.page-count-span {
  float: right;
  margin-top: 26px;
  color: #ea7a1c;
}
.p-16 {
  padding: 0 16px !important;
}
.pull--right {
  float: right;
}
.color-orange {
  color: #ea7a1c !important;
  font-size: 25px;
  padding-top: 15px;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}
.color-grey-light {
  color: grey;
}

.job-documents-page {
  --doc-border: #e4e7ec;
  --doc-bg: #f6f5f2;
  --doc-ink: #172033;
  --doc-muted: #667085;
  --doc-orange: #f58220;
  --doc-orange-dark: #d96a10;
  --doc-soft: #fff7ed;
  background: var(--doc-bg);
  min-height: calc(100vh - 64px);
  padding: 10px 14px 24px !important;
}

.job-documents-page .job-documents-header,
.job-documents-page .job-documents-content {
  background: #ffffff !important;
  border: 1px solid var(--doc-border) !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  margin-bottom: 10px;
  overflow: hidden;
}

.job-documents-page .job-documents-header .v-card__title {
  background: #ffffff !important;
  border-bottom: 1px solid var(--doc-border);
  padding: 8px 12px !important;
}

.job-documents-page .v-btn--floating {
  background: var(--doc-soft) !important;
  border: 1px solid #fed7aa !important;
  box-shadow: none !important;
  color: #a85510 !important;
  height: 34px !important;
  min-width: 34px !important;
  width: 34px !important;
}

.job-documents-page .color-orange {
  color: var(--doc-ink) !important;
  font-size: 18px !important;
  font-weight: 900;
  padding-top: 0;
}

.job-documents-page .color-grey-light {
  color: var(--doc-muted);
  font-size: 12px;
  font-weight: 800;
}

.job-documents-page .job-documents-content > .flex {
  padding-top: 0 !important;
}

.job-documents-page .job-documents-tabs-wrap {
  background: #ffffff;
  border-bottom: 1px solid var(--doc-border);
  padding: 12px 16px;
}

.job-documents-page .job-documents-segmented {
  background: #edebe5 !important;
  border-radius: 0.6875rem !important;
  padding: 0.25rem !important;
}

.job-documents-page .job-documents-segmented .segmented-control__item {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #74716a !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: auto !important;
  letter-spacing: 0 !important;
  min-height: 1.75rem !important;
  min-width: max-content !important;
  padding: 0.4375rem 0.75rem !important;
  text-transform: none !important;
}

.job-documents-page .job-documents-segmented .segmented-control__item--active {
  background: #ffffff !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.13) !important;
  color: #1a1916 !important;
}

#nav .job-documents-page .job-documents-segmented .segmented-control__item,
#nav .job-documents-page .job-documents-segmented button {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #74716a !important;
  height: auto !important;
  min-height: 1.75rem !important;
  min-width: max-content !important;
  padding: 0.4375rem 0.75rem !important;
}

#nav .job-documents-page .job-documents-segmented .segmented-control__item--active {
  background: #ffffff !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.13) !important;
  color: #1a1916 !important;
}

.job-documents-page .job-documents-tab-panel {
  display: block;
  padding: 0 !important;
}

.job-documents-page .job-documents-tab-panel > .v-card,
.job-documents-page .job-documents-tab-panel > .nospace {
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.job-documents-page .job-documents-tab-panel .v-card__text.nospace {
  padding: 0 !important;
}

.job-documents-page .job-documents-tab-panel .v-card__text.nospace > .v-card__text.nospace {
  background: var(--doc-soft) !important;
  border-bottom: 1px solid #fed7aa;
  padding: 12px 16px !important;
}

.job-documents-page .job-documents-tab-panel .layout.p-16 {
  align-items: center;
  border-top: 0 !important;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  min-height: 52px;
  padding: 0 !important;
}

.job-documents-page .job-documents-tab-panel .layout.p-16 > .flex {
  flex: 0 1 auto !important;
  max-width: none !important;
  min-width: 0;
  padding: 0 !important;
}

.job-documents-page .job-documents-tab-panel .layout.p-16 > .flex:last-child,
.job-documents-page .job-documents-tab-panel .layout.p-16 > div:last-child {
  margin-left: auto;
  text-align: right;
}

.job-documents-page .m-t-20 {
  margin-top: 0 !important;
}

.job-documents-page #TransporterListTable,
.job-documents-page #ListTable {
  border: 1px solid var(--doc-border);
  border-radius: 0;
  border-width: 0 0 1px;
  overflow: hidden;
}

.job-documents-page .v-table__overflow {
  overflow-x: auto;
}

.job-documents-page table.v-table {
  min-width: 760px;
}

.job-documents-page table.v-table thead th {
  background: var(--doc-orange) !important;
  border-bottom: 1px solid var(--doc-orange-dark) !important;
  color: #ffffff !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  text-transform: uppercase;
}

.job-documents-page table.v-table thead th .v-icon,
.job-documents-page table.v-table thead th span {
  color: #ffffff !important;
}

.job-documents-page table.v-table tbody td {
  border-bottom: 1px solid #edf1f6 !important;
  color: var(--doc-ink);
  font-size: 12px !important;
  font-weight: 700;
  padding: 10px 12px !important;
  vertical-align: middle;
}

.job-documents-page .document-link img {
  background: #ffffff;
  border: 1px solid var(--doc-border);
  border-radius: 7px;
  box-shadow: none;
  height: 34px !important;
  object-fit: contain;
  padding: 4px;
  width: 34px !important;
}

.job-documents-page .track-ass-btn,
.job-documents-page .red-button,
.job-documents-page .v-btn:not(.v-btn--floating):not(.v-btn--icon) {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  min-height: 30px;
  text-transform: none;
}

.job-documents-page .track-ass-btn {
  background: var(--doc-orange) !important;
  border: 1px solid var(--doc-orange) !important;
  color: #ffffff !important;
  padding: 6px 10px !important;
}

.job-documents-page .red-button {
  background: #fff1f0 !important;
  border: 1px solid #fecdca !important;
  color: #b42318 !important;
}

.job-documents-page .page-count-span {
  color: #a85510;
  display: inline-flex;
  float: none;
  font-size: 12px;
  font-weight: 900;
  margin: 12px 0 0;
}

.theme--dark .job-documents-page,
.application--dark .job-documents-page {
  --doc-border: #2b3545;
  --doc-bg: #0f172a;
  --doc-ink: #f8fafc;
  --doc-muted: #aab4c3;
  background: var(--doc-bg);
}

.theme--dark .job-documents-page .job-documents-header,
.theme--dark .job-documents-page .job-documents-content,
.theme--dark .job-documents-page #documents,
.application--dark .job-documents-page .job-documents-header,
.application--dark .job-documents-page .job-documents-content,
.application--dark .job-documents-page #documents {
  background: #111827 !important;
  border-color: var(--doc-border) !important;
}

.theme--dark .job-documents-page table.v-table thead th,
.application--dark .job-documents-page table.v-table thead th {
  background: #172033 !important;
  color: #cbd5e1 !important;
}

.theme--dark .job-documents-page table.v-table tbody td,
.application--dark .job-documents-page table.v-table tbody td {
  border-color: #273244 !important;
  color: #f8fafc;
}
</style>
